import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import { __assign, __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "upload-title"
}, [/*#__PURE__*/_createElementVNode("svg", {
  width: "19",
  height: "19",
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("g", {
  "clip-path": "url(#clip0_1613_4468)"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M16.2059 8.94138C16.2059 8.64496 16.3236 8.36068 16.5332 8.15108C16.7428 7.94148 17.0271 7.82373 17.3235 7.82373C17.62 7.82373 17.9042 7.94148 18.1138 8.15108C18.3234 8.36068 18.4412 8.64496 18.4412 8.94138V14.201C18.4412 16.8498 16.3087 19.0002 13.6722 19.0002H5.32784C2.69131 19.0002 0.558838 16.8498 0.558838 14.201V8.94138C0.558838 8.64496 0.67659 8.36068 0.886189 8.15108C1.09579 7.94148 1.38007 7.82373 1.67648 7.82373C1.9729 7.82373 2.25718 7.94148 2.46678 8.15108C2.67638 8.36068 2.79413 8.64496 2.79413 8.94138V14.201C2.79413 15.6193 3.93078 16.7649 5.32784 16.7649H13.6722C15.0692 16.7649 16.2059 15.6193 16.2059 14.201V8.94138Z",
  fill: "#333333"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M9.49997 1.11768C10.2451 1.11768 10.6176 1.49022 10.6176 2.23532V13.4118C10.6176 14.1569 10.2451 14.5294 9.49997 14.5294C8.75487 14.5294 8.38232 14.1569 8.38232 13.4118V2.23532C8.38232 1.49022 8.75487 1.11768 9.49997 1.11768Z",
  fill: "#333333"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M9.44412 3.16065L6.28117 6.32248C6.07038 6.52606 5.78806 6.63872 5.49502 6.63617C5.20198 6.63362 4.92166 6.51608 4.71444 6.30886C4.50722 6.10164 4.38967 5.82132 4.38713 5.52828C4.38458 5.23523 4.49723 4.95291 4.70082 4.74212L8.65394 0.790123C8.86353 0.580596 9.14776 0.462891 9.44412 0.462891C9.74048 0.462891 10.0247 0.580596 10.2343 0.790123L14.1852 4.74212C14.2919 4.84522 14.3771 4.96855 14.4356 5.10491C14.4942 5.24126 14.525 5.38792 14.5263 5.53632C14.5276 5.68472 14.4993 5.83189 14.4432 5.96925C14.387 6.1066 14.304 6.23139 14.199 6.33633C14.0941 6.44127 13.9693 6.52426 13.8319 6.58045C13.6946 6.63665 13.5474 6.66493 13.399 6.66364C13.2506 6.66235 13.104 6.63152 12.9676 6.57294C12.8312 6.51437 12.7079 6.42922 12.6048 6.32248L9.44412 3.16065Z",
  fill: "#333333"
})]), /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_1613_4468"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "19",
  height: "19",
  fill: "white"
})])])]), /*#__PURE__*/_createElementVNode("span", {
  class: "txt"
}, "上传讲解视频")], -1);
var _hoisted_2 = {
  class: "upload-area"
};
var _hoisted_3 = {
  class: "upload-box"
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "ant-upload-drag-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://img.pipacoding.com/assets/ug-fe-contest/20250408/upload-icon.png",
  alt: ""
})], -1);
var _hoisted_5 = /*#__PURE__*/_createElementVNode("p", {
  class: "ant-upload-text"
}, "将文件拖到此处或点击上传", -1);
var _hoisted_6 = {
  class: "record-tips"
};
var _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "other-tips"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "line line-left"
}), /*#__PURE__*/_createElementVNode("span", {
  class: "txt"
}, "温馨提示"), /*#__PURE__*/_createElementVNode("span", {
  class: "line line-right"
})]), /*#__PURE__*/_createElementVNode("div", {
  class: "item-tips"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "index"
}, "1、"), /*#__PURE__*/_createElementVNode("p", {
  class: "cont"
}, [/*#__PURE__*/_createTextVNode(" 请优先使用页面内的 "), /*#__PURE__*/_createElementVNode("span", {
  class: "orange"
}, "录制讲解视频工具"), /*#__PURE__*/_createTextVNode(" ，酌情选择第三方工具进行录屏。 ")])]), /*#__PURE__*/_createElementVNode("div", {
  class: "item-tips"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "index"
}, "2、"), /*#__PURE__*/_createElementVNode("p", {
  class: "cont"
}, [/*#__PURE__*/_createTextVNode(" 苹果电脑屏幕录制可以使用系统快捷键 "), /*#__PURE__*/_createElementVNode("span", {
  class: "orange"
}, " (Command+Shift+ 5) 、 QuickTime Player、iMovie "), /*#__PURE__*/_createTextVNode(" 或其他第三方工具。 ")])]), /*#__PURE__*/_createElementVNode("div", {
  class: "item-tips"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "index"
}, "3、"), /*#__PURE__*/_createElementVNode("p", {
  class: "cont"
}, " Windows电脑屏幕录制可以使用Windows10/11内置的XboxGame Bar，按下 Win+G组合键即可快速启动录制功能，也可选择其他第三方工具。 ")]), /*#__PURE__*/_createElementVNode("div", {
  class: "item-tips"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "index"
}, "4、"), /*#__PURE__*/_createElementVNode("p", {
  class: "cont"
}, " 上传视频仅保留最新上传结果，上传结束后可通过“查看讲解视频“按钮查看上传的视频。 ")])], -1);
import { ref, computed } from 'vue';
import { RecordVideoService } from '@/services/recordVideo/recordVideo.service';
import { useService } from '@kaokei/use-vue-service';
import { logger } from '@/utils';
import { CosService } from '@/services/cosmaz.service';
import { ExamService } from '@/services/exam/exam.service';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var _this = this;
    var recordVideoService = useService(RecordVideoService);
    var cosService = useService(CosService);
    var examService = useService(ExamService);
    var visible = ref(true);
    var showCloseable = ref(true);
    var handleOk = function () {
      visible.value = false;
    };
    var fileList = ref([]);
    var handleChange = function (info) {
      var status = info.file.status;
      // 只保留最新的文件
      fileList.value = [info.file];
      if (status !== 'uploading') {
        logger.info(info.file, info.fileList);
      }
      if (status === 'done') {
        logger.info("".concat(info.file.name, " file uploaded successfully."));
      } else if (status === 'error') {
        logger.error("".concat(info.file.name, " file upload failed."));
      }
    };
    var onBeforeUpload = function (file, fileList) {
      var _a;
      var limitSizeCount = ((_a = examService.introductionVideoConfig) === null || _a === void 0 ? void 0 : _a.maxSize) || 30;
      var isLimitSize = file.size / 1024 / 1024 < limitSizeCount;
      if (!isLimitSize) {
        _message.error("\u6587\u4EF6".concat(file.name, "\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7").concat(limitSizeCount, "M"), 4);
        // 从文件列表中删除超出大小限制的文件
        var index = fileList.findIndex(function (f) {
          return f.uid === file.uid;
        });
        if (index > -1) {
          fileList.splice(index, 1);
        }
      }
      return isLimitSize;
    };
    var onCosUpload = function (_a) {
      var file = _a.file,
        onSuccess = _a.onSuccess,
        onError = _a.onError,
        onProgress = _a.onProgress;
      return __awaiter(_this, void 0, void 0, function () {
        var suffix, fileName, response, error_1;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              showCloseable.value = false;
              _b.label = 1;
            case 1:
              _b.trys.push([1, 3,, 4]);
              suffix = '.'.concat(file.name.split('.').pop() || '');
              fileName = cosService.getBlobName('/contest-file', suffix);
              return [4 /*yield*/, cosService.uploadBlob({
                blob: file,
                fileName: fileName,
                cosType: 'introductionVideo',
                onProgress: function (progress) {
                  onProgress({
                    percent: progress.percent * 100
                  });
                }
              })];
            case 2:
              response = _b.sent();
              onSuccess(__assign(__assign({}, response), {
                url: response.Location
              }), file);
              // message.success(`文件：${file.name}上传成功`);
              onUpload(response.Location);
              return [3 /*break*/, 4];
            case 3:
              error_1 = _b.sent();
              onError(error_1);
              _message.error("\u6587\u4EF6\uFF1A".concat(file.name, "\u4E0A\u4F20\u5931\u8D25"));
              showCloseable.value = true;
              return [3 /*break*/, 4];
            case 4:
              return [2 /*return*/];
          }
        });
      });
    };
    var onUpload = function (url) {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          // 操作来源,包括submitExam-考试页面,
          // contestList-赛事列表页面
          examService.uploadRecordVideoData({
            url: url,
            optSource: recordVideoService.isVisibleCheck ? 'submitExam' : 'contestList'
          }).then(function () {
            recordVideoService.videoUploadVisible = false;
            recordVideoService.hideRecordCom();
            _message.success('提交成功', 2, function () {
              window.location.reload();
            });
            showCloseable.value = true;
          }).catch(function () {
            showCloseable.value = true;
          });
          return [2 /*return*/];
        });
      });
    };
    var acceptType = computed(function () {
      var _a;
      var typeVal = ((_a = examService.introductionVideoConfig) === null || _a === void 0 ? void 0 : _a.videoType) || '';
      var resTypeVal = typeVal.startsWith('.') ? typeVal : '.'.concat(typeVal);
      return resTypeVal || '.mp4';
    });
    var acceptUploadWords = computed(function () {
      var _a;
      return ((_a = examService.introductionVideoConfig) === null || _a === void 0 ? void 0 : _a.uploadWords) || '';
    });
    return function (_ctx, _cache) {
      var _component_a_upload_dragger = _resolveComponent("a-upload-dragger");
      var _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_a_modal, {
        visible: _unref(recordVideoService).videoUploadVisible,
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return _unref(recordVideoService).videoUploadVisible = $event;
        }),
        title: "",
        onOk: handleOk,
        width: "589px",
        centered: "",
        wrapClassName: "screen-recorder-upload__video",
        footer: null,
        maskClosable: false,
        keyboard: false,
        closable: showCloseable.value
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_upload_dragger, {
            fileList: fileList.value,
            "onUpdate:fileList": _cache[0] || (_cache[0] = function ($event) {
              return fileList.value = $event;
            }),
            name: "file",
            onChange: handleChange,
            beforeUpload: onBeforeUpload,
            customRequest: onCosUpload,
            accept: _unref(acceptType)
          }, {
            default: _withCtx(function () {
              return [_hoisted_4, _hoisted_5];
            }),
            _: 1
          }, 8, ["fileList", "accept"])]), _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(acceptUploadWords)), 1), _hoisted_7])])];
        }),
        _: 1
      }, 8, ["visible", "closable"])]);
    };
  }
});